<template>
  <el-table-column
    prop="addresses"
    label="Címek"
    show-overflow-tooltip
    min-width="230"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.customers && scope.row.customers.length"
        v-for="customer in scope.row.customers"
      >
        {{ customer.address }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'addresses',
};
</script>
